// extracted by mini-css-extract-plugin
export default {"card":"NotasAlumno_card__MXSJn","placeholder":"NotasAlumno_placeholder__MClq6","fab":"NotasAlumno_fab__bJBzd"};